import produce, { current } from 'immer'
import { ADD_CALL, DIALPAD, TRANSFER } from 'constants/General'
import * as C from './constants'

const sessionsReducer = (state = C.INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case C.OUTGOING_CREATE:
        draft.activeSessionIndex += 1
        break
      case C.INCOMING_CREATE:
        break
      case C.INCOMING_ACCEPT:
        draft.activeSessionIndex = action.payload
        break
      case C.CONNECTING:
        draft.list[action.payload].connected = false
        draft.list[action.payload].connecting = true
        draft.list[action.payload].mediaConnected = false
        draft.list[action.payload].isPlayLocalRingTone = false
        break
      case C.MEDIA_CONNECTED:
        draft.list[action.payload].mediaConnected = true
        draft.list[action.payload].isPlayLocalRingTone = false
        break
      case C.IS_PLAY_LOCAL_RING_TONE:
        draft.list[action.payload].isPlayLocalRingTone = true
        break
      case C.ACCEPTED:
        draft.list[action.payload].connected = true
        draft.list[action.payload].connecting = false
        draft.list[action.payload].mediaConnected = true
        draft.list[action.payload].isPlayLocalRingTone = false
        draft.list[action.payload].startTime = new Date()
        draft.activeSessionIndex = action.payload
        break
      case C.SESSION_TERMINATED:
        draft.error = action.payload.error || false
        break
      case C.SESSIONS_MERGED_TERMINATED:
        draft.error = action.payload || false
        break
      case C.SESSION_ENDED:
        // remove from list
        draft.list[action.payload] = undefined
        // check if other sessions exist
        if (current(draft).list.filter(Boolean).length > 0) {
          // set active session
          draft.activeSessionIndex = draft.list.findIndex(Boolean)
        } else {
          // reset sessions
          draft.list = []
          draft.activeSessionIndex = -1
        }
        // check if merged
        if (draft.merged.ids.includes(action.payload)) {
          // remove from merged
          draft.merged.ids.splice(draft.merged.ids.indexOf(action.payload), 1)
          // reset other merged sessions
          draft.merged.ids.forEach((id) => {
            draft.list[id].merged = false
          })
          // list should only have 1 more session
          if (draft.merged.ids.length === 1) {
            // make other session the active one
            draft.activeSessionIndex = draft.merged.ids[0] // eslint-disable-line prefer-destructuring
          }
          // reset merged ui
          draft.merged = C.INITIAL_STATE.merged
        }
        // if warm transfer call is ended, or middle of starting warm transfer
        // warm transfer is canceled
        if (
          draft.warmTransfer.ids.includes(action.payload) ||
          draft.warmTransfer.pendingId
        ) {
          // reset sessions
          draft.warmTransfer.ids.forEach((id) => {
            if (draft.list[id]) {
              draft.list[id].warmTransferring = false
            }
          })
          // reset warm transfer
          draft.warmTransfer = C.INITIAL_STATE.warmTransfer
        }
        // reset ui
        if (!draft.list.length) {
          draft.dialpad = false
          draft.transfer = false
          draft.action = false
          draft.silenced = false
        }
        break
      case C.SESSION_ADD:
        draft.list.push(action.payload)
        draft.dialpad = false
        draft.transfer = false
        draft.action = false
        break
      case C.SESSION_TRANSFER_VOICEMAIL:
      case C.SESSION_TRANSFER:
        draft.transfer = false
        draft.list[action.payload].connected = false
        draft.list[action.payload].transferring = true
        break
      case C.SESSION_TRANSFER_WARM_SET:
        draft.list[action.payload.index].warmTransferring = true
        draft.warmTransfer.ids.push(action.payload.index)
        draft.warmTransfer.transferring = true
        if (action.payload.isPending) {
          draft.warmTransfer.pendingId = false
        }
        break
      case C.SESSION_TRANSFER_WARM_PENDING:
        draft.warmTransfer.pendingId = action.payload
        break
      case C.SESSION_TRANSFER_WARM_FULFILLED:
        draft.warmTransfer = C.INITIAL_STATE.warmTransfer
        break
      case C.SESSION_PARK_PENDING: {
        const { id, timeout } = action.payload
        draft.list[id].parked = false
        draft.list[id].parking = true
        draft.parkingTimeout[id] = timeout
        break
      }
      case C.SESSION_PARK_FULFILLED: {
        const { id, sessionId } = action.payload
        const { [sessionId]: timeoutId, ...parkingTimeout } =
          draft.parkingTimeout
        clearTimeout(timeoutId)
        draft.parkingTimeout = parkingTimeout
        draft.list[sessionId].parked = true
        draft.list[sessionId].parking = false
        draft.parked[id] = action.payload
        break
      }
      case C.SESSION_PARK_REJECTED: {
        const sessionId = action.payload
        const { [sessionId]: timeoutId, ...parkingTimeout } =
          draft.parkingTimeout
        clearTimeout(timeoutId)
        draft.parkingTimeout = parkingTimeout
        if (draft.list[sessionId]) {
          draft.list[sessionId].parked = false
          draft.list[sessionId].parking = false
        }
        break
      }
      case C.SESSION_UNPARKED:
      case C.SESSION_UNPARKED_ELSEWHERE:
      case C.SESSION_PARK_TERMINATED:
        // Pay attention that parked session ID is different from session ID
        // for example, parked sessionID: 79001 (park slot), sessionID: 1 (index)
        delete draft.parked[action.payload]
        break
      case C.MUTE_TOGGLE:
        draft.list[draft.activeSessionIndex].mute = action.payload
        break
      case C.HOLD_TOGGLE:
        draft.list[draft.activeSessionIndex].hold = action.payload
        break
      case C.HOLD_ACTIVE:
        draft.list[action.payload].hold = true
        break
      case C.UNHOLD_ACTIVE:
        draft.list[draft.activeSessionIndex].hold = false
        break
      case C.ADD_HOLD_TOGGLING:
        draft.list[action.payload].holdToggling = true
        break
      case C.REMOVE_HOLD_TOGGLING:
        draft.list[action.payload].holdToggling = false
        break
      case C.TRANSFER_TOGGLE:
        draft.action = draft.action ? false : TRANSFER
        break
      case C.DIALPAD_TOGGLE:
        draft.action = draft.action ? false : DIALPAD
        break
      case C.ADD_CALL_TOGGLE:
        draft.action = draft.action ? false : ADD_CALL
        break
      case C.ACTION_CLEAR:
        draft.action = false
        break
      case C.SESSION_ACTIVE_TOGGLE:
        draft.activeSessionIndex = action.payload
        break
      case C.SESSIONS_MERGE:
        draft.merged.ids = action.payload
        draft.merged.ids.forEach((index) => {
          draft.list[index].merged = true
        })
        break
      case C.UNHOLD_MERGED:
        draft.merged.hold = false
        draft.merged.ids.forEach((id) => {
          draft.list[id].hold = false
        })
        break
      case C.UNMUTE_MERGED:
        draft.merged.mute = false
        draft.merged.ids.forEach((id) => {
          draft.list[id].mute = false
        })
        break
      case C.TRACKS_UNMIX_MERGED:
        draft.merged.tracksAreMixed = false
        break
      case C.REMOVE_DELAY_MIX_MERGED:
        draft.merged.needToMixWithDelay = false
        break
      case C.HOLD_MERGED:
        draft.merged.hold = true
        draft.merged.ids.forEach((id) => {
          draft.list[id].hold = true
        })
        break
      case C.MUTE_MERGED:
        draft.merged.mute = true
        draft.merged.ids.forEach((id) => {
          draft.list[id].mute = true
        })
        break
      case C.TRACKS_MIX_MERGED:
        draft.merged.tracksAreMixed = true
        break
      case C.ADD_DELAY_MIX_MERGED:
        draft.merged.needToMixWithDelay = true
        break
      case C.ADD_RECEIVED_STREAM_MERGED:
        draft.merged.receivedStream = action.payload
        break
      case C.HOLD_TOGGLE_MERGED:
        draft.merged.hold = action.payload
        draft.merged.ids.forEach((id) => {
          draft.list[id].hold = action.payload
        })
        break
      case C.MUTE_TOGGLE_MERGED:
        draft.merged.mute = action.payload
        draft.merged.ids.forEach((id) => {
          draft.list[id].mute = action.payload
        })
        break
      case C.TRACKS_TOGGLE_MERGED:
        draft.merged.tracksAreMixed = action.payload
        break
      case C.TOGGLE_DELAY_MIX_MERGED:
        draft.merged.needToMixWithDelay = action.payload
        break
      case C.INCOMING_SILENCE:
        draft.silenced = true
        break
      default:
        break
    }
  })
}

export default sessionsReducer
